<template>
  <div class="checkout">
    <div class="checkout-heading">
      <h2>{{ trans.text['thank-you'].title }}</h2>
      <p>{{ trans.text['thank-you'].redirectMessage }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['lang', 'trans', 'stat'],
  name: "CheckoutComponent",
  data() {
    return {}
  },
  mounted() {
    if (this.stat && this.stat.items) {
      this.$gtag.event('purchase', {
        currency: 'EUR',
        items: this.stat.items,
        transaction_id: this.stat.transaction_id,
      })
      setTimeout(() => {
        if (window.fbq) {
          window.fbq('track', 'Purchase', {
            currency: 'EUR',
            value: 1000,
            content_type: 'product',
            num_items: this.stat.items.length,
            contents: this.stat.items.map(item => {
              return {
                id: item.variant,
                quantity: item.quantity,
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.checkout-heading {
  min-height: 400px;
}
</style>
